module.exports = __webpack_public_path__ + "static/media/infographics.c65c5d40.png";